/* @flow */
import {
  GET_DISCOUNTS,
  UPDATE_CACHED_DISCOUNTS,
  UPDATE_COUPON_STATE,
  GET_ACCOUNT_COUPONS,
  UPDATE_CACHED_COUPONS
} from '../configs/constants'

export function getDiscounts() {
  return { type: GET_DISCOUNTS }
}

export function updateCachedDiscounts(discounts) {
  return {
    type: UPDATE_CACHED_DISCOUNTS,
    payload: discounts,
  }
}

export function updateCouponStatus(discountId, coupon, uid) {
  return {
    type: UPDATE_COUPON_STATE,
    payload: {
      discountId,
      coupon,
      uid,
    }
  }
}

export function getAccountCoupons(uid) {
  return {
    type: GET_ACCOUNT_COUPONS,
    uid,
  }
}

export function updateCachedCoupons(coupons) {
  return {
    type: UPDATE_CACHED_COUPONS,
    coupons
  }
}


// WEBPACK FOOTER //
// ./src/actions/discount.js